export default __webpack_public_path__ + "static/media/fine_enhancement_ore.a5bcfbb6.png";